module.exports = __webpack_public_path__ + "static/media/religare_icn_landing_card_2.ee53c12c.png";